<template>
  <div>
    <errorDialog :mainColor="mainColor" v-model="error"></errorDialog>

    <v-dialog v-model="dialog">
      <embed
        src="./WholeLifeBrochure.pdf"
        type="application/pdf"
        width="100%"
        height="100%"
      />
    </v-dialog>
    <div
      v-if="$vuetify.breakpoint.smAndDown && products && products.length > 0"
    >
      <v-layout justify-center class="padTop">
        <v-flex xs10>
          <!-- tab control -->

          <v-tabs dark :color="mainColor">
            <v-menu bottom left>
              <template v-slot:activator="{ on }">
                <v-btn
                  text
                  class="align-self-center mr-4"
                  v-on="on"
                  :color="mainColor"
                >
                  PRODUCTS
                  <v-icon right>arrow_drop_down</v-icon>
                </v-btn>
              </template>

              <template>
                <v-layout row class="wrapper">
                  <v-flex xs12 class="wrapper-inner">
                    <v-card>
                      <v-list dense subheader>
                        <v-subheader style="font-size: 15px"
                          >PRODUCTS</v-subheader
                        >

                        <v-list-tile
                          name="productMenu"
                          v-for="(product, idx) in products"
                          :key="idx"
                          ripple
                        >
                          <v-list-tile-content>
                            <v-list-tile-title @click="selectProduct(idx)">{{
                              product.name
                            }}</v-list-tile-title>
                            <!-- <v-list-tile-sub-title>{{ item.subtitle }}</v-list-tile-sub-title> -->
                          </v-list-tile-content>
                        </v-list-tile>
                      </v-list>
                    </v-card>
                  </v-flex>
                </v-layout>
              </template>
            </v-menu>

            <v-tab-item>
              <v-card color="white">
                <v-layout>
                  <!-- product information headers and detail -->
                  <v-flex xs12>
                    <v-layout align-center align-content-center justify-center>
                      <v-flex xs11>
                        <v-img
                          height="400"
                          :src="require('@/assets/' + currentProduct.img)"
                          aspect-ratio="1"
                          contain
                        ></v-img>
                      </v-flex>
                    </v-layout>

                    <div
                      class="infoDiv"
                      v-for="point in this.currentProduct.talkingPoints"
                      :key="point.product"
                      :style="{ color: mainColor }"
                    >
                      <v-card-title
                        v-if="point.header"
                        v-html="point.header"
                        class="pointHeader"
                      ></v-card-title>
                      <v-card-text
                        v-if="point.detail"
                        v-html="point.detail"
                        class="pointDetail"
                      ></v-card-text>
                      <v-card-text
                        v-if="point.smallText"
                        v-html="point.smallText"
                        class="smallText"
                      ></v-card-text>
                    </div>

                    <br />
                    <br />

                    <v-card-text
                      class="smallText pointDetail bottomDetail"
                      :style="{ color: mainColor }"
                      >*Product availability will be based on Insured's
                      Eligibility for coverage.</v-card-text
                    >
                    <v-card-text
                      class="smallText pointDetail bottomDetail"
                      :style="{ color: mainColor }"
                      v-if="currentProduct.name.indexOf('Whole Life') >= 0"
                    >
                      <sup>♦</sup>See terms of policy for restrictions and
                      limitations.
                    </v-card-text>
                    <div
                      class="infoDiv"
                      v-for="point in this.currentProduct.talkingPoints"
                      :key="point.product"
                      :style="{ color: mainColor }"
                    >
                      <v-card-text
                        v-for="disclaimer in point.disclaimers"
                        :key="disclaimer.text"
                        v-html="disclaimer.text"
                        class="smallText pointDetail bottomDetail"
                      ></v-card-text>
                    </div>
                  </v-flex>
                </v-layout>
                <br />
                <br />
                <v-layout
                  align-content-center
                  align-center
                  justify-center
                  column
                >
                  <a
                    @click="openBrochure"
                    style="width: 105px"
                    v-if="currentProduct.name.indexOf('Cancer') < 0"
                  >
                    <v-img
                      :src="require('@/assets/LifeThumbnail.png')"
                      height="241"
                      contain
                      aspect-ratio="1.7"
                    ></v-img>
                  </a>
                  <br />
                  <br />
                  <a
                    @click="openBrochure"
                    style="display: inline-block"
                    v-if="currentProduct.name.indexOf('Cancer') < 0"
                    >Click Here for our Whole Life Brochure</a
                  >
                  <a
                    @click="openBrochureCancer"
                    style="display: inline-block; width: 212px"
                    v-if="currentProduct.name.indexOf('Cancer') >= 0"
                  >
                    <v-img
                      :src="require('@/assets/CancerThumbnail.png')"
                      height="277"
                      contain
                    ></v-img>
                  </a>
                  <br /><br />
                  <a
                    @click="openBrochureCancer"
                    style="display: inline-block"
                    v-if="currentProduct.name.indexOf('Cancer') >= 0"
                  >
                    <span>Click Here for our Cancer Brochure</span>
                  </a>
                  <span
                    v-if="currentProduct.name.indexOf('Cancer') >= 0"
                    style="color: gray; margin: 10px"
                  >
                    <br /><br /><br /><br />
                    This is a solicitation for insurance. Policies and benefits
                    may vary by state and product. These policies have some
                    limitations and exclusions. Policy form: (CANLS-2)</span
                  >
                  <br />
                  <br />
                </v-layout>
                <br />
                <br />
                <br />
              </v-card>
            </v-tab-item>
          </v-tabs>
        </v-flex>
      </v-layout>
    </div>

    <div v-if="$vuetify.breakpoint.mdAndUp && products && products.length > 0">
      <v-layout row wrap justify-center class="padTop">
        <v-flex xs10>
          <!-- tab control -->
          <v-tabs :color="mainColor" dark v-model="tab" class="activeFade">
            <!-- tab slider -->
            <v-tabs-slider color="green"></v-tabs-slider>
            <!-- tab headers -->
            <v-tab
              v-model="tab"
              @change="selectProduct(idx)"
              v-for="(product, idx) in products"
              :key="product.id"
              ripple
              >{{ product.name }}</v-tab
            >
            <!-- tab details -->
            <v-tab-item v-model="tab">
              <v-card color="white" style="padding-top: 20px">
                <v-layout>
                  <!-- product information headers and detail -->
                  <v-flex xs7 justify-start>
                    <div
                      class="infoDiv"
                      v-for="point in this.currentProduct.talkingPoints"
                      :key="point.product"
                      :style="{ color: mainColor }"
                    >
                      <v-card-title
                        v-if="point.header"
                        v-html="point.header"
                        class="pointHeader"
                      ></v-card-title>
                      <v-card-text
                        v-if="point.detail"
                        v-html="point.detail"
                        class="pointDetail"
                      ></v-card-text>
                      <v-card-text
                        v-if="point.smallText"
                        v-html="point.smallText"
                        class="smallText"
                      ></v-card-text>
                    </div>
                    <br />
                    <br />
                    <v-layout align-content-center justify-center>
                      <a
                        @click="openBrochureCancer"
                        v-if="currentProduct.name.indexOf('Cancer') >= 0"
                        style="display: inline-block"
                      >
                        <v-img
                          :src="require('@/assets/CancerThumbnail.png')"
                          height="277"
                          contain
                        ></v-img>

                        <br />
                        <span>Click Here for our Cancer Brochure</span>
                      </a>
                    </v-layout>
                    <br />
                    <br />
                  </v-flex>
                  <!-- image and product disclaimers -->
                  <v-flex xs5 class="rightPadding">
                    <v-img
                      height="400"
                      :src="require('@/assets/' + currentProduct.img)"
                      aspect-ratio="1"
                      contain
                    ></v-img>
                    <br />
                    <br />

                    <span class="disclaimer" :style="{ color: mainColor }"
                      >Product availability will be based on Insured's
                      Eligibility for coverage.</span
                    >
                    <br /><br />
                    <div class="infoDiv">
                      <v-card-text
                        class="smallText pointDetail bottomDetail"
                        :style="{ color: mainColor }"
                        v-if="currentProduct.name.indexOf('Whole Life') >= 0"
                      >
                        <sup>♦</sup>See terms of policy for restrictions and
                        limitations.
                      </v-card-text>
                    </div>

                    <div
                      class="infoDiv"
                      v-for="point in this.currentProduct.talkingPoints"
                      :key="point.product"
                      :style="{ color: mainColor }"
                    >
                      <v-card-text
                        v-for="disclaimer in point.disclaimers"
                        :key="disclaimer.text"
                        v-html="disclaimer.text"
                        class="smallText pointDetail bottomDetail"
                      ></v-card-text>
                    </div>
                    <br />
                    <br />
                    <a
                      @click="openBrochure"
                      style="display: inline-block; width: 105px"
                      v-if="currentProduct.name.indexOf('Cancer') < 0"
                    >
                      <v-img
                        :src="require('@/assets/LifeThumbnail.png')"
                        height="241"
                        contain
                      ></v-img>
                    </a>
                    <br />
                    <br />
                    <a
                      @click="openBrochure"
                      style="display: inline-block"
                      v-if="currentProduct.name.indexOf('Cancer') < 0"
                    >
                      <span>Click Here for our Whole Life Brochure</span>
                    </a>
                  </v-flex>
                </v-layout>
                <span
                  style="color: gray"
                  v-if="currentProduct.name.indexOf('Cancer') >= 0"
                >
                  <br /><br />
                  This is a solicitation for insurance. Policies and benefits
                  may vary by state and product. These policies have some
                  limitations and exclusions. Policy form: (CANLS-2)</span
                ><br /><br />
              </v-card>
            </v-tab-item>
          </v-tabs>
        </v-flex>
      </v-layout>
    </div>
    <!-- <v-layout align-content-center justify-center>
      <div
        v-if="products && products.length > 0"
        :style="'margin-top:30px;padding:20px;background: #00558c; min-height:100px; width: '+bannerWidth+'px;'"
      >
        <span style="color:white">
          Contact us at
          <a
            href="mailto:ESD_SofNM@globe.life"
            style="color:white;text-decoration:none;"
          >ESD_SofNM@globe.life</a> to learn more.
          <br />
          <br />
          <a @click="showVideo" style="color:white;">CLICK HERE for a product presentation</a>
        </span>
      </div>
    </v-layout>-->
  </div>
</template>

<script>
import { AWS_HTTP } from '../http-common.js'
import { log } from '../http-common.js'

export default {
  props: { mainColor: String, entity: Object },
  name: 'products',
  components: {
    errorDialog: () =>
      import(/* webpackPrefetch: true */ '../components/error-dialog.vue'),
  },
  data() {
    return {
      error: false,
      dialog: false,
      productMenu: 1,
      selectedIndex: 0,
      tab: null,
      products: [],
      myBannerWidth: window.innerWidth - 50,
    }
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.getWindowWidth)
  },
  created() {
    window.addEventListener('resize', this.getWindowWidth)

    AWS_HTTP.get('product-details', {
      params: {
        entity: this.entity.id,
        // state: this.entity.state
      },
    })
      .then((response) => {
        let body = JSON.parse(response.data.body)

        //console.log(body)

        this.products = body[0].products
      })
      .catch((e) => {
        log(e.toString(), true, 'Products.vue created')
        this.error = true
      })
  },
  computed: {
    bannerWidth: function () {
      return this.myBannerWidth
    },
    currentProduct: {
      get: function () {
        return this.products[this.selectedIndex]
      },
    },
  },
  methods: {
    getWindowWidth() {
      this.myBannerWidth = window.innerWidth - 50
    },
    showVideo() {
      let width = window.innerWidth - 200
      window.open(
        './ProductPresentation.mp4',
        '_blank',
        'toolbar=yes,scrollbars=yes,resizable=yes,left=100,width=' +
          width +
          ',height=1000'
      )
    },

    selectProduct(idx) {
      this.selectedIndex = idx
    },
    openBrochure() {
      let width = window.innerWidth - 200
      window.open(
        './WholeLifeBrochure.pdf',
        '_blank',
        'toolbar=yes,scrollbars=yes,resizable=yes,left=100,width=' +
          width +
          ',height=1000'
      )
    },
    openBrochureCancer() {
      let width = window.innerWidth - 200
      window.open(
        './CancerBrochure.pdf',
        '_blank',
        'toolbar=yes,scrollbars=yes,resizable=yes,left=100,width=' +
          width +
          ',height=1000'
      )
    },
  },
}
</script>

<style>
.v-tabs__item.v-tabs__item--active {
  background: rgba(255, 255, 255, 0.15);
}
</style>

<style scoped lang="stylus">
#custom-transition {
  .fade {
    &-enter-active, &-leave-active, &-leave-to {
      transition: 0.3s ease-out;
      position: absolute;
      top: 0;
      left: 0;
    }

    &-enter, &-leave, &-leave-to {
      opacity: 0;
    }
  }
}

.pointHeader {
  font-weight: normal;
  font-family: 'Open Sans', Arial, Verdana, sans-serif;
  font-weight: bold;
  font-size: 20px;
}

.pointDetail {
  font-weight: normal;
  font-family: 'Open Sans', Arial, Verdana, sans-serif;
  font-size: 14px;
  padding-bottom: 0px;
  padding-top: 0px;
}

.infoDiv {
  text-align: left;
  overflow-y: auto;
}

.smallText {
  font-weight: normal;
  font-family: 'Open Sans', Arial, Verdana, sans-serif;
  font-size: small;
}

.disclaimer {
  font-weight: normal;
  font-family: 'Open Sans', Arial, Verdana, sans-serif;
  font-size: small;
  padding-bottom: 0px;
  margin-top: 25px;
}

.bottomDetail {
  padding-bottom: 20px;
}

.rightPadding {
  margin-right: 10px;
}

.padTop {
  padding-top: 50px;
}

.wrapper {
  display: flex;
}

.wrapper-inner {
  flex-basis: 100%;
}

.v-tabs__item {
  white-space: normal;
  display: inline-block !important;
}
</style>